import { useState, useEffect } from 'react';
import { WINDOW_STYLES, WindowStyleConfig } from '../config/windowStyles';

// Function to compare arrays of window styles
function haveStylesChanged(oldStyles: WindowStyleConfig[], newStyles: WindowStyleConfig[]): boolean {
  if (oldStyles.length !== newStyles.length) return true;
  
  return oldStyles.some((oldStyle, index) => {
    const newStyle = newStyles[index];
    return (
      oldStyle.id !== newStyle.id ||
      oldStyle.name !== newStyle.name ||
      oldStyle.category !== newStyle.category ||
      oldStyle.previewPath !== newStyle.previewPath ||
      oldStyle.emailPath !== newStyle.emailPath ||
      oldStyle.description !== newStyle.description
    );
  });
}

// Custom event for style updates
const STYLES_UPDATED_EVENT = 'windowStylesUpdated';

// Function to emit style update event
export function notifyStylesUpdated(newStyles: WindowStyleConfig[]) {
  window.dispatchEvent(new CustomEvent(STYLES_UPDATED_EVENT, { detail: newStyles }));
}

export function useWindowStylesWatcher() {
  const [windowStyles, setWindowStyles] = useState<WindowStyleConfig[]>(WINDOW_STYLES);
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());

  useEffect(() => {
    let isSubscribed = true;
    let timeoutId: NodeJS.Timeout;

    const checkForChanges = () => {
      // Use the imported WINDOW_STYLES directly
      if (isSubscribed && haveStylesChanged(windowStyles, WINDOW_STYLES)) {
        console.log('[WindowStylesWatcher] Detected changes in window styles');
        setWindowStyles(WINDOW_STYLES);
        setLastUpdate(new Date());
      }

      // Schedule next check if still subscribed
      if (isSubscribed) {
        timeoutId = setTimeout(checkForChanges, 2000); // Check every 2 seconds
      }
    };

    // Start checking for changes
    checkForChanges();

    // Cleanup on unmount
    return () => {
      isSubscribed = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [windowStyles]);

  return {
    windowStyles,
    lastUpdate
  };
} 